import {RouterProps} from "../../../RouterProps";
import {useParams} from "react-router-dom";
import {useStatePair} from "react-type-extension";
import {
    ContentUserProductionDurationValueObject
} from "../../../../data/value-object/content/ContentUserProductionDurationValueObject";
import {useEffect} from "react";
import {
    ContentUserProductionDurationIO,
    ContentUserProductionDurationModificationIO
} from "../../../../io/ContentIO";
import {Body1, Spinner, Tab} from "@fluentui/react-components";
import {DetailDefaultPanel, DetailTab} from "../../../DetailViews";
import {ContentUserProductionDurationDomain} from "../../../../data/domain/content/ContentUserProductionDurationDomain";
import {ContentUserProductionDurationDescriptor} from "../../../../data/descriptor/content/ContentUserProductionDurationDescriptor";
import {ContentUserProductionDurationDescription} from "../../../../data/description/content/ContentUserProductionDurationDescription";
import {
    ContentUserProductionDurationModificationValueObject
} from "../../../../data/value-object/content/ContentUserProductionDurationModificationValueObject";
import {
    ContentUserProductionDurationModificationSearchOption
} from "../../../../data/search-option/content/ContentUserProductionDurationModificationSearchOption";
import {searchIndex, SearchIndex} from "../../../../io/HttpClient";
import ListPageWrapper from "../../../ListPageWrapper";
import {
    ContentUserProductionDurationModificationDescription
} from "../../../../data/description/content/ContentUserProductionDurationModificationDescription";
import {
    ContentUserProductionDurationModificationDescriptor
} from "../../../../data/descriptor/content/ContentUserProductionDurationModificationDescriptor";

enum Panel {
    Default,
    ContentUserProductionDurationModificationList,
}

export default function Detail(props: RouterProps) {
    const params = useParams<{ contentUserProductionDurationId: string }>()
    const item = useStatePair<ContentUserProductionDurationValueObject | undefined>(undefined)

    useEffect(() => {
        if (item.value === undefined && params.contentUserProductionDurationId !== undefined) {
            ContentUserProductionDurationIO
                .getById(BigInt(params.contentUserProductionDurationId))
                .then(item.setter)
                .catch(reason => {
                    console.error(reason)
                    alert('오류가 발생했습니다.')
                })
        }
    }, []);

    return <>
        {item.value === undefined && <Spinner />}
        {item.value !== undefined && <Page {...props} item={item.value} /> }
    </>
}

type PageProps = RouterProps & {
    item: ContentUserProductionDurationValueObject
}

function Page(props: PageProps) {
    const panel = useStatePair<Panel>(Panel.Default)
    return <>
        <div className={props.styles.row16}>
            <DetailTab
                {...props}
                panel={panel}>
                <Tab value={Panel.Default}>상세</Tab>
                <Tab value={Panel.ContentUserProductionDurationModificationList}>수정 이력</Tab>
            </DetailTab>
            <DetailDefaultPanel
                {...props}
                client={ContentUserProductionDurationIO}
                description={ContentUserProductionDurationDescription}
                properties={props => <PropertyBody {...props} />}/>
            <ContentUserProductionDurationModificationListPanel
                {...props}
                panel={panel.value}/>
        </div>
    </>
}

type PropertyBodyProps = PageProps & {
    itemKey: keyof ContentUserProductionDurationDomain
}

function PropertyBody(props: PropertyBodyProps) {
    switch (props.itemKey) {
        case "id":
        case "value":
        case "displayOrder":
        case "lastModifiedAt":
        case "createdAt":
            return <Body1>{ContentUserProductionDurationDescriptor[props.itemKey](props.item)}</Body1>
        case "creatorId":
            return <a href={`/users/${props.item.creatorId}`}><Body1>{ContentUserProductionDurationDescriptor[props.itemKey](props.item)}</Body1></a>
    }
}

type PanelProps = PageProps & {
    panel: Panel
    children?: false | JSX.Element | JSX.Element[]
}

function ContentUserProductionDurationModificationListPanel(props: PanelProps) {
    const modifications = useStatePair<ContentUserProductionDurationModificationValueObject[]>([])
    const modificationSearchOption: ContentUserProductionDurationModificationSearchOption = { contentUserProductionDurationIdEq: props.item.id }
    const modificationSearchIndex = useStatePair<SearchIndex>(searchIndex())

    return <>
        {props.panel === Panel.ContentUserProductionDurationModificationList && <>
            <ListPageWrapper
                {...props}
                client={ContentUserProductionDurationModificationIO}
                items={modifications}
                option={modificationSearchOption}
                index={modificationSearchIndex}
                description={ContentUserProductionDurationModificationDescription}
                descriptor={ContentUserProductionDurationModificationDescriptor}
                showNewTab={false}
                onItemClick={item => `/contents/userProduction/durations/${item.id}`} />
        </>}
    </>
}